import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { ContactuspageComponent } from './pages/contactuspage/contactuspage.component';
import { Homepage2Component } from './pages/homepage2/homepage2.component';
import { DownloadpageComponent } from './pages/downloadpage/downloadpage.component';
import { SubmitSuccessfullComponent } from './pages/submit-successfull/submit-successfull.component';
import { CreditratingpageComponent } from './pages/creditratingpage/creditratingpage.component';
import { ResearchDashboardPageComponent } from './pages/research-dashboard-page/research-dashboard-page.component';
import { OnlineclientportalpageComponent } from './pages/onlineclientportalpage/onlineclientportalpage.component';


const routes: Routes = [
  {
    path: '',
    component: HomepageComponent,
    data: {
      title: 'Best Brokerage Firm in Pakistan- MSL Trade',
      description: 'Looking for the best brokerage firm in Pakistan? Then MSL is the right choice for you! Because it is the best brokerage house in Pakistan, based in Karachi.'
    }
  },
  {
    path: 'aboutus',
    loadChildren: () => import('./pages/aboutus/aboutus.module').then((m) => m.AboutusModule),
  },
  {
    path: 'ourservice',
    loadChildren: () => import('./pages/ourservice/ourservice.module').then((m) => m.OurserviceModule),
  },
  {
    path: 'governance',
    loadChildren: () => import('./pages/governance/governance.module').then((m) => m.GovernanceModule),
  },
  {
    path: 'invester-information',
    loadChildren: () => import('./pages/investor-information/investor-information.module').then((m) => m.InvestorInformationModule),
  },
  {
    path: 'education-center',
    loadChildren: () => import('./pages/education-center/education-center.module').then((m) => m.EducationCenterModule),
  },
  {
    path: 'home2',
    component: Homepage2Component
  },
  // {
  //   path: 'vision',
  //   component: VisionpageComponent,
  //   data: {
  //     title: 'Top Brokerage Firms- MSL Trade',
  //     description: 'Finding brokerage firms in Pakistan? Choose the top brokerage firms in Pakistan and the best companies to invest in Pakistan Stock Exchange and multiply your return on investment.'
  //   }
  // },
  // {
  //   path: 'company_overview',
  //   component: IntroductionpageComponent,
  //   data: {
  //     title: 'PSX Brokerage Firms- MSL Trade',
  //     description: 'PSX brokerage firms stand to be the first choice and the better way to earn maximum return on stock exchange investment in Pakistan.'
  //   }
  // },
  // {
  //   path: 'services',
  //   component: OurservicespageComponent,
  //   data: {
  //     title: 'Top Brokerage Firms- MSL Trade',
  //     description: 'Finding brokerage firms in Pakistan? Choose the top brokerage firms in Pakistan and the best companies to invest in Pakistan Stock Exchange and multiply your return on investment.'
  //   }
  // },
  // {
  //   path: 'research',
  //   component: ResearchpageComponent,
  //   data: {
  //     title: 'Top Brokerage Firms- MSL Trade',
  //     description: 'Finding brokerage firms in Pakistan? Choose the top brokerage firms in Pakistan and the best companies to invest in Pakistan Stock Exchange and multiply your return on investment.'
  //   }
  // },
  // {
  //   path: 'equitysale',
  //   component: EquitysalespageComponent,
  //   data: {
  //     title: 'Top Brokerage Firms- MSL Trade',
  //     description: 'Finding brokerage firms in Pakistan? Choose the top brokerage firms in Pakistan and the best companies to invest in Pakistan Stock Exchange and multiply your return on investment.'
  //   }
  // },
  // {
  //   path: 'commodity',
  //   component: CommoditiespageComponent,
  //   data: {
  //     title: 'Top Brokerage Firms- MSL Trade',
  //     description: 'Finding brokerage firms in Pakistan? Choose the top brokerage firms in Pakistan and the best companies to invest in Pakistan Stock Exchange and multiply your return on investment.'
  //   }
  // },
  // {
  //   path: 'conrporatefinanceandadvisory',
  //   component: CorporateFinanceAndAdvisoryComponent,
  //   data: {
  //     title: 'Top Brokerage Firms- MSL Trade',
  //     description: 'Finding brokerage firms in Pakistan? Choose the top brokerage firms in Pakistan and the best companies to invest in Pakistan Stock Exchange and multiply your return on investment.'
  //   }
  // },
  // {
  //   path: 'management',
  //   component: ManagementpageComponent,
  //   data: {
  //     title: 'Brokerage Firms in Karachi- MSL Trade',
  //     description: 'Invest only with the top brokerage firms in Pakistan. Get high returns on your investment with finding and investing with the leading brokerage firms in Karachi.'
  //   }
  // },
  // {
  //   path: 'managementpmex',
  //   component: ManagmentpmexpageComponent,
  //   data: {
  //     title: 'Brokerage Firms in Karachi- MSL Trade',
  //     description: 'Invest only with the top brokerage firms in Pakistan. Get high returns on your investment with finding and investing with the leading brokerage firms in Karachi.'
  //   }
  // },
  // {
  //   path: 'managementpsx',
  //   component: ManagmentpsxpageComponent,
  //   data: {
  //     title: 'Brokerage Firms in Karachi- MSL Trade',
  //     description: 'Invest only with the top brokerage firms in Pakistan. Get high returns on your investment with finding and investing with the leading brokerage firms in Karachi.'
  //   }
  // },
  // {
  //   path: 'offices',
  //   component: OfficespageComponent
  // },
  // {
  //   path: 'boardofdirectors',
  //   component: BoardofdirectorpageComponent
  // },
  // {
  //   path: 'sponsor',
  //   component: SponsorpageComponent
  // },
  // {
  //   path: 'auditcommittee',
  //   component: AuditcommitteepageComponent
  // },
  // {
  //   path: 'rickmanagementcommittee',
  //   component: RickmanagementcommitteepageComponent
  // },
  // {
  //   path: 'accountopening',
  //   component: AccountopeningpageComponent
  // },
  // {
  //   path: 'accountform',
  //   component: AccountopeningformComponent
  // },
  {
    path: 'contact',
    component: ContactuspageComponent
  },
  // {
  //   path: 'financialstatement',
  //   component: FinancialstatementspageComponent
  // },
  // {
  //   path: 'liquidcapital',
  //   component: LiquidcapitalpageComponent
  // },
  // {
  //   path: 'netcapital',
  //   component: NetcapitalpageComponent
  // },
  // {
  //   path: 'ncb-auditor',
  //   component: NcbauditorpageComponent
  // },
  // {
  //   path: 'auditor-legal-advisor',
  //   component: AuditorlegaladvicerpageComponent
  // },
  // {
  //   path: 'investor-complaints',
  //   component: InvestorcomplaintspageComponent
  // },
  // {
  //   path: 'penal-action',
  //   component: PanelactionpageComponent
  // },
  // {
  //   path: 'rules-regulations',
  //   component: RulespageComponent
  // },
  // {
  //   path: 'shareholding-pattern',
  //   component: PatternofshareholdingpageComponent
  // },
  // {
  //   path: 'faq',
  //   component: FaqpageComponent
  // },
  // {
  //   path: 'Fipilipi',
  //   component: FipilipipageComponent
  // },
  {
    path: 'download',
    component: DownloadpageComponent
  },
  {
    path: 'SubmitSuccessfull',
    component: SubmitSuccessfullComponent
  },
  // {
  //   path: 'accountopeningprocess',
  //   component: AccountopeningprocessComponent,
  //   data: {
  //     title: 'Investment in Pakistan Stock Exchange- MSL Trade',
  //     description: 'Investment in Pakistan Stock Exchange is an easier way to multiply your money. Find the best brokerage firms to invest in Pakistan Stock Market and get an abundant financial life.'
  //   }
  // },
  // {
  //   path: 'registrationsecp',
  //   component: RegistrationsecppageComponent,
  //   data: {
  //     title: 'Online Stock Exchange Pakistan- MSL Trade',
  //     description: 'Choose the right firm for stock market investment in Pakistan which can easily transform your financial life with a convenient online stock exchange in Pakistan.  '
  //   }
  // },
  // {
  //   path: 'registrationpmexsecp',
  //   component: RegistrationpmexsecppageComponent,
  //   data: {
  //     title: 'Online Stock Exchange Pakistan- MSL Trade',
  //     description: 'Choose the right firm for stock market investment in Pakistan which can easily transform your financial life with a convenient online stock exchange in Pakistan.  '
  //   }
  // },
  // {
  //   path: 'securitiesandfuturesadviser',
  //   component: SecuritiesandfuturesadviserpageComponent,
  //   data: {
  //     title: 'Top Brokerage Firms- MSL Trade',
  //     description: 'Finding brokerage firms in Pakistan? Choose the top brokerage firms in Pakistan and the best companies to invest in Pakistan Stock Exchange and multiply your return on investment.'
  //   }
  // },
  // {
  //   path: 'underwriter',
  //   component: UnderwriterpageComponent,
  //   data: {
  //     title: 'Top Brokerage Firms- MSL Trade',
  //     description: 'Finding brokerage firms in Pakistan? Choose the top brokerage firms in Pakistan and the best companies to invest in Pakistan Stock Exchange and multiply your return on investment.'
  //   }
  // },
  // {
  //   path: 'consultanttotheissue',
  //   component: ConsultanttotheissuepageComponent,
  //   data: {
  //     title: 'Top Brokerage Firms- MSL Trade',
  //     description: 'Finding brokerage firms in Pakistan? Choose the top brokerage firms in Pakistan and the best companies to invest in Pakistan Stock Exchange and multiply your return on investment.'
  //   }
  // },
  // {
  //   path: 'rating',
  //   component: RatingpageComponent
  // },
  {
    path: 'credit-rating-press-release',
    component: CreditratingpageComponent
  },
  // {
  //   path: 'management-rating-press-release',
  //   component: ManagementratingpageComponent
  // },
  {
    path: 'research-dashboard',
    component: ResearchDashboardPageComponent
  },
  {
    path: 'online-client-portal',
    component: OnlineclientportalpageComponent
  },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
